export default {"src":"/_next/static/media/diftman-window.77ea5214.svg","height":85,"width":80,"blurWidth":0,"blurHeight":0};